import { render, staticRenderFns } from "./TeamChatModal.vue?vue&type=template&id=ec7fc952&"
import script from "./TeamChatModal.vue?vue&type=script&lang=js&"
export * from "./TeamChatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports